import { LATEST_AUDIT_MODELS_URL } from 'constants/ApiConstants';

import * as actionTypes from '../actionTypes';

/**
 * @param {string} token
 * @param {import('modules/auditModels/types').AuditModelsSelectFilters} params
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').InitializeAuditModelSelectorAction}
 */
export const initializeAuditModelsSelector = (token, params, meta = {}) => ({
  type: actionTypes.INIT_AUDIT_MODELS_SELECT,
  payload: {
    token,
    params,
  },
  meta,
});

/**
 * @param {string} token
 * @param {import('modules/auditModels/types').GetAuditModelsSelectActionPayload} params
 * @param {{ target : 'active' | 'findByDealerIdOrGroupId', shouldUpdate?: boolean, [field: string]?: any }} [meta={}]
 * @returns {import('modules/auditModels/types').GetAuditModelsSelectAction}
 */
export const getAuditModelsSelect = (token, params, meta = {}) => {
  const { target = 'active' } = params;
  return {
    type: actionTypes.GET_AUDIT_MODELS_SELECT_FETCH,
    payload: {
      request: {
        method: 'GET',
        url: `${LATEST_AUDIT_MODELS_URL}/search/${target}`,
        params,
      },
      token,
    },
    meta,
  };
};

/**
 * @param {string} token
 * @param {import('modules/global/generic.types.js').PageContent<import('modules/auditModels/types').AuditModelSelect>} data
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').GetAuditModelsSelectSuccessAction}
 */
export const getAuditModelsSelectSuccess = (token, data, meta = {}) => ({
  type: actionTypes.GET_AUDIT_MODELS_SELECT_FETCH_SUCCESS,
  payload: {
    ...data,
    token,
  },
  meta,
});

/**
 * @param {string} token
 * @param {string} message
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').GetAuditModelsSelectFailureAction}
 */
export const getAuditModelsSelectFailure = (token, message, meta = {}) => ({
  type: actionTypes.GET_AUDIT_MODELS_SELECT_FETCH_FAILURE,
  payload: {
    message,
    token,
  },
  meta,
});

/**
 * @param {Object} params
 * @param {{ selectId?: string, [field:string]: any }} [meta={}]
 * @returns {import('modules/auditModels/types').GetAuditModelsSelectAction}
 */
export const fetchAuditModelsSelect = (params, meta = {}) => getAuditModelsSelect(meta.selectId, params, meta);

/**
 * @param {string} token
 * @param {{[field:string] : any}} filters
 * @param {Object} [meta={}]
 * @returns {import('modules/auditModels/types').setAuditModelSelectFilters}
 */
export const setAuditModelsSelectFilters = (token, filters, meta = {}) => ({
  type: actionTypes.SET_AUDIT_MODELS_SELECT_FILTERS,
  payload: {
    filters,
    token,
  },
  meta,
});
